import script from "./anchor.vue?vue&type=script&setup=true&lang=ts"
export * from "./anchor.vue?vue&type=script&setup=true&lang=ts"

import "./anchor.vue?vue&type=style&index=0&id=1915ee47&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1915ee47"]])

export default __exports__